import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { Button } from "../../../../components/wpl/button/src/index";

const backgroundStyles = css({
    display: "flex",
    flexDirection: "column",
    margin: "auto 16px",
    backgroundImage:
        "url(https://wac-cdn.atlassian.com/dam/jcr:4b129f91-c947-46e4-b1b9-e5949c2f1a7a/bg_hv.svg?cdnVersion=1223)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    alignItems: "stretch",
    overflow: "hidden",
    textAlign: "center",
    gap: "24px",
    [media.above.sm]: {
        flexDirection: "row",
        textAlign: "left",
        gap: 0
    }
});

const titleImageStyles = css({
    flex: "1 25%",
    display: "flex",
    justifyContent: "center",
    paddingBlockStart: "34px",
    boxSizing: "border-box",
    [media.above.sm]: {
        padding: `${token("space.200")}`
    },
    img: {
        maxWidth: "100%",
        width: "198px"
    }
});

const descriptionStyles = css({
    display: "flex",
    flex: "1 75%",
    flexDirection: "column",
    alignItems: "center",
    paddingBlockEnd: "22px",
    paddingInlineStart: "16px",
    paddingInlineEnd: "16px",
    boxSizing: "border-box",
    gap: "24px",
    [media.above.sm]: {
        gap: 0,
        flexDirection: "row",
        paddingBlockEnd: 0
    },
    [media.above.md]: {
        flex: "1 58.33333%"
    }
});

const descriptionTextColumnStyles = css({
    flex: "1 100%",
    boxSizing: "border-box",
    [media.above.sm]: {
        paddingBlockEnd: "22px",
        paddingBlockStart: "16px"
    }
});

const descriptionButtonStyles = css({
    flex: "1 0%",
    boxSizing: "border-box",
    fontWeight: 500,
    [media.above.sm]: {
        paddingInlineStart: "16px"
    }
});

const locationStyles = css({
    flex: "1 16.66666%",
    padding: `0 ${token("space.200")} 0 ${token("space.200")}`,
    boxSizing: "border-box",
    display: "flex",
    alignItems: "flex-end",
    img: {
        verticalAlign: "bottom",
        width: "100%"
    },
    [media.below.md]: {
        display: "none"
    }
});

export const AdBanner = () => {
    const intl = useIntl();

    const tagline = (
        <FormattedMessage
            id="AdBanner.descriptionTagline.onDemand"
            defaultMessage={"On demand"}
        />
    );
    const description = (
        <FormattedMessage
            id="AdBanner.description.campaignOct23.onDemand"
            defaultMessage={
                "Catch the keynote and other sessions from our biggest service management event of the year."
            }
        />
    );
    const ctaText = intl.formatMessage({
        id: "AdPattern.GetYourTicketButton.onDemand",
        defaultMessage: "Watch now"
    });
    const ctaUrl =
        "https://events.atlassian.com/highvelocity?ref=High_Velocity&utm_source=marketing&utm_campaign=on-demand&utm_content=lifted_banner_homepage_11.8&utm_medium=website";

    return (
        <div css={backgroundStyles}>
            <div css={titleImageStyles}>
                <img
                    src="https://wac-cdn.atlassian.com/dam/jcr:e1f31cb5-84ff-4b60-99f5-f8b932c82f1e/logo_high-velocity.svg?cdnVersion=1223"
                    alt={intl.formatMessage({
                        id: "AdPattern.HighVelocityTextLogoAlt",
                        defaultMessage: "High velocity text logo"
                    })}
                />
            </div>
            <div css={descriptionStyles}>
                <div css={descriptionTextColumnStyles}>
                    <p
                        css={css({
                            marginBlockEnd: 0,
                            marginBlockStart: 0
                        })}
                    >
                        <strong>{tagline}</strong>
                    </p>
                    <p
                        css={css({
                            marginBlockEnd: 0,
                            marginBlockStart: 0
                        })}
                    >
                        {description}
                    </p>
                </div>
                <div css={descriptionButtonStyles}>
                    <Button
                        size={"small"}
                        dataEventProps={{
                            "data-event-component": "linkButton",
                            "data-event-container": "banner-link-button",
                            "data-product-key": "jiraSoftware",
                            "data-event": "clicked"
                        }}
                        url={ctaUrl}
                        css={css({
                            whiteSpace: "nowrap",
                            fontWeight: 500
                        })}
                        text={ctaText}
                    />
                </div>
            </div>
            <div css={locationStyles}>
                <img
                    src="https://wac-cdn.atlassian.com/dam/jcr:d09d8bd1-4313-4048-af08-9836bc0edb94/sydney.png?cdnVersion=1223"
                    alt={intl.formatMessage({
                        id: "AdPattern.OperaHouseImageAlt",
                        defaultMessage: "Sydney opera house"
                    })}
                />
            </div>
        </div>
    );
};
